__turbopack_context__.v({
  "text": "zawHSG_text",
  "topNavigationBarItem": "zawHSG_topNavigationBarItem" + " " + __turbopack_context__.i(248112)["focusOutline"],
});
